/* Intent-only document warming. Never intercept clicks or execute a destination. */
(function () {
  var connection = navigator.connection;
  if (connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType))) return;
  var supportsRules = typeof HTMLScriptElement.supports === 'function' && HTMLScriptElement.supports('speculationrules');
  var warmed = new Set();
  var rules = [];
  var hints = [];
  var pending = null;
  var timer;
  var suspended = false;

  function consentResolved() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      var consent = privacy && privacy.currentVisitorConsent();
      return !!consent && ['analytics', 'marketing', 'preferences'].every(function (key) {
        return consent[key] === 'yes' || consent[key] === 'no';
      });
    } catch (error) { return false; }
  }

  function destination(target) {
    var link = target && target.closest && target.closest('a[href]');
    if (!link || (link.target && link.target !== '_self') || link.hasAttribute('download')) return null;
    if (link.closest('[data-no-prefetch], .no-prefetch, [data-ajax], [data-prevent-loader], .lv-option-item-link')) return null;
    try {
      var url = new URL(link.href, location.href);
      if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return null;
      // Include localized and collection-scoped PDPs; exclude all actions,
      // account/cart routes, filters, preview changes and in-page fragments.
      if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:products\/[^/]+|collections\/[^/]+(?:\/products\/[^/]+)?)\/?$/i.test(url.pathname)) return null;
      if (url.hash || Array.from(url.searchParams.keys()).some(function (key) { return key !== 'variant'; })) return null;
      if (url.href === location.href) return null;
      return { link: link, href: url.href };
    } catch (error) { return null; }
  }

  function warm(candidate) {
    if (suspended || !consentResolved() || !candidate || document.visibilityState === 'hidden' || warmed.has(candidate.href)) return;
    if (!supportsRules && warmed.size >= 8) return;
    warmed.add(candidate.href);
    if (supportsRules) {
      var rule = document.createElement('script');
      rule.type = 'speculationrules';
      rule.textContent = JSON.stringify({ prefetch: [{ urls: [candidate.href], eagerness: 'immediate' }] });
      document.head.appendChild(rule);
      rules.push({ element: rule, href: candidate.href });
      if (rules.length > 2) {
        var oldest = rules.shift();
        oldest.element.remove();
        warmed.delete(oldest.href);
      }
    } else {
      var hint = document.createElement('link');
      hint.rel = 'prefetch';
      hint.as = 'document';
      hint.href = candidate.href;
      document.head.appendChild(hint);
      hints.push(hint);
    }
  }

  function cancel() { clearTimeout(timer); pending = null; }
  function invalidate() {
    // Removing our hints cannot recall browser-owned or completed prefetches.
    // Stop new warming for this document while native consent state changes.
    suspended = true;
    cancel();
    rules.forEach(function (rule) { rule.element.remove(); });
    hints.forEach(function (hint) { hint.remove(); });
    rules = [];
    hints = [];
    warmed.clear();
  }
  document.addEventListener('alasil:consent-saving', invalidate);
  document.addEventListener('visitorConsentCollected', invalidate);
  document.addEventListener('pointerover', function (event) {
    if (suspended || event.pointerType === 'touch') return;
    var candidate = destination(event.target);
    if (pending && candidate && pending.link === candidate.link) return;
    cancel();
    if (!candidate) return;
    pending = candidate;
    timer = setTimeout(function () { warm(candidate); pending = null; }, 100);
  }, { passive: true });
  document.addEventListener('pointerout', function (event) {
    if (pending && !pending.link.contains(event.relatedTarget)) cancel();
  }, { passive: true });
  document.addEventListener('focusin', function (event) { warm(destination(event.target)); }, { passive: true });
  // Speculation requests can be reused by the impending navigation. Do not
  // start the legacy HTTP-cache fallback on tap: no-store would fetch twice.
  document.addEventListener('pointerdown', function (event) {
    cancel();
    if (supportsRules && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) warm(destination(event.target));
  }, { passive: true });
  window.addEventListener('pagehide', cancel);
})();
